import { useMemo, useState } from "react";
import {
  GoogleMap,
  InfoBox,
  InfoWindow,
  Marker,
  OverlayView,
} from "@react-google-maps/api";
import classes from "./Maps.module.css";
import { MapPin } from "../../stories/MapPin/MapPin";
import SearchResultsPopup from "../PopUps/Map/SearchResults";

export default function MapView({ location, className, data }) {
  const center = useMemo(
    () => (location !== undefined ? location : data[0]?.location),
    [location, data]
  );
  const [activeMarker, setActiveMarker] = useState(null);

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  return (
    <div className={`${classes?.Container} ${className && className}`}>
      {/* Map */}
      <GoogleMap
        zoom={12}
        center={center}
        mapContainerClassName={classes["map-container"]}
      >
        {data !== undefined &&
          data.length > 0 &&
          data.map((e, i) => (
            <>
              <OverlayView
                position={e.location}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
              >
                <>
                  <MapPin
                    value={e.id}
                    onClick={() => {
                      handleActiveMarker(e.id);
                    }}
                  />
                </>
              </OverlayView>
              {activeMarker === e.id && (
                <InfoWindow
                  position={e.location}
                  onCloseClick={() => setActiveMarker(null)}

                >
                  <SearchResultsPopup />
                </InfoWindow>
              )}
            </>
          ))}
        {location && (
          <OverlayView
            position={location}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <>
              <MapPin value={1} />
            </>
          </OverlayView>
        )}
      </GoogleMap>
    </div>
  );
}
